import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "../components/Logo";
import { useAuth } from "../contexts/AuthContext";
import { useI18n } from "../contexts/I18nContext";
import { formatApiError } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  const { login, user } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) {
    const redir = sessionStorage.getItem("post_login_redirect");
    if (redir) { sessionStorage.removeItem("post_login_redirect"); navigate(redir, { replace: true }); }
    else navigate("/dashboard", { replace: true });
  } }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      const redir = sessionStorage.getItem("post_login_redirect");
      if (redir) { sessionStorage.removeItem("post_login_redirect"); navigate(redir); }
      else navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] px-4">
      <div className="w-full max-w-md pp-card-elevated p-8" data-testid="login-card">
        <Link to="/" className="block mb-8"><Logo /></Link>
        <h1 className="font-heading text-3xl font-bold">{t("login")}</h1>
        <p className="text-zinc-400 text-sm mt-2">{t("welcome_back")}</p>

        <button onClick={googleLogin} data-testid="login-google" className="mt-6 w-full pp-btn-secondary px-4 py-3 rounded-xl flex items-center justify-center gap-2">
          <span className="font-bold text-[#00E676]">G</span> {t("continue_with_google")}
        </button>

        <div className="my-5 flex items-center gap-3 text-xs text-zinc-500"><div className="flex-1 border-t border-white/10" /> {t("or")} <div className="flex-1 border-t border-white/10" /></div>

        <form onSubmit={submit} className="space-y-3">
          <input data-testid="login-email" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("email")} className="pp-input" />
          <input data-testid="login-password" required type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder={t("password")} className="pp-input" />
          <button data-testid="login-submit" disabled={loading} className="w-full pp-btn-primary px-4 py-3 rounded-xl">{loading ? "..." : t("login")}</button>
        </form>

        <p className="mt-5 text-sm text-zinc-400">
          {t("no_account")} <Link to="/register" data-testid="login-to-register" className="text-[#00E676] hover:underline">{t("register")}</Link>
        </p>
      </div>
    </div>
  );
}
